import { useCallback } from 'react';
import {
  google,
  outlook,
  office365,
  yahoo,
  ics,
  CalendarEvent,
} from 'calendar-link';

export const useCalendarLinks = (event: CalendarEvent) => {
const downloadICS = useCallback(() => {
  const icsContent = ics(event); // returns the .ics string
  const encoded = encodeURIComponent(icsContent);
  const dataUrl = `data:text/calendar;charset=utf-8,${encoded}`;

  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = `${event.title || 'event'}.ics`;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}, [event]);


  return {
    googleUrl: google(event),
    outlookUrl: outlook(event),
    office365Url: office365(event),
    yahooUrl: yahoo(event),
    icsDownload: downloadICS,
  };
};
